import { Document, Font, Page, StyleSheet, Image, Text, View } from "@react-pdf/renderer";
import React from "react";
import PropTypes from "prop-types";
import calculateTimeDifference from "../../../extension/differenceDate";
import { convertDate } from "../../../extension/dateConvert";

Font.register({
  family: "Vazir",
  src: "/fonts/Vazirmatn-FD-Medium.ttf",
});

const PdfReportStopRegistration = ({ data }) => {
  const styles = StyleSheet.create({
    page: {
      padding: 30,
      fontSize: 10,
      fontFamily: "Vazir",
    },
    section2: {
      marginBottom: 10,
    },
    section: {
      margin: 10,
      padding: 10,
      border: "1pt solid black",
      borderRadius: 5,
    },
    headerRow: {
      flexDirection: "row",
      justifyContent: "space-between",
      alignItems: "center",
      marginBottom: 10,
    },
    rows: {
      flexDirection: "row",
    },
    row: {
      flexDirection: "row",
      justifyContent: "space-between",
      borderBottom: "1pt solid black",
      paddingVertical: 8,
      rowGap:7,
      gap:7
    },
    column: {
      flex: 1,
      textAlign: "right",
      direction: "rtl",
    },
    footer: {
      textAlign: "center",
      borderTop: "1pt solid black",
      paddingTop: 10,
      marginTop: 10,
    },
    header: {
      textAlign: "right",
      direction: "rtl",
      marginBottom: 10,
    },
    title: {
      textAlign: "center",
      fontSize: 14,
      marginBottom: 10,
      fontWeight: "bold",
    },
    titleContainer: {
      flexDirection: "row",
      justifyContent: "center",
      alignItems: "center",
      marginBottom: 10,
    },
    logo: {
      width: 30,
      height: 30,
    },
    imageContainer: {
      marginTop: 10,
      display: "flex",
      flexDirection: "row",
      flexWrap: "wrap",
    },
    imageWrapper: {
      margin: 5,
      textAlign: "center",
      width: 80,
    },
    thumbnail: {
      width: 80,
      height: 80,
      marginBottom: 5,
    },
  });
  const chunkArray = (array, size) => {
    const result = [];
    for (let i = 0; i < array.length; i += size) {
      result.push(array.slice(i, i + size));
    }
    return result;
  };
  const parsePelak = (pelak) => {
    if (!pelak) return null;

    const part1 = pelak.slice(0, 2);
    const part2 = pelak.slice(2, 3);
    const part3 = pelak.slice(3, 6);
    const part4 = pelak.slice(6);

    return { part1, part2, part3, part4 };
  };
  const pages = chunkArray(data, 2);

  return (
    <Document>
      {pages.map((pageItems, pageIndex) => (
        <Page size="A4" style={styles.page} key={pageIndex}>
          {pageItems.map((item, ind) => (
            <View style={styles.section2} key={ind}>
              <View style={styles.headerRow}>
                <Image src="/images/ic_launcher.png" style={styles.logo} />
                <Text style={styles.title}>{process.env.REACT_APP_PDF_TITLE}</Text>

              </View>
              <View style={styles.header}>
                <Text>نوع گزارش: توقف</Text>
              </View>

              <View style={styles.section}>
                <View style={styles.row}>
                  <Text style={styles.column}>ساعت: {item.created_at?.split(" ")[0]}</Text>
                  <Text style={styles.column}>تاریخ: {convertDate(item.created_at?.split(" ")[1])}</Text>
                  <Text style={styles.column}>مسئول: {item.user?.name ?? '--'}</Text>
                  <Text style={styles.column}>شرح: {item.desc ?? '--'}</Text>
                </View>
                <View style={styles.row}>
                  <Text style={styles.column}>تاریخ پایان: {convertDate(item.endDate) ?? '--'}</Text>
                  <Text style={styles.column}>تاریخ شروع: {convertDate(item.startDate)}</Text>
                  <Text style={styles.column}>ساعت پایان: {item.endTime ?? '--'}</Text>
                  <Text style={styles.column}>ساعت شروع: {item.startTime ?? '--'}</Text>
                </View>
                <View style={styles.row}>
                  <Text style={styles.column}>راننده: {item.driver?.name ?? '--'}</Text>
                  <Text style={styles.column}>ساعت مجاز: {item.allowTime ?? '--'}</Text>
                  <Text style={styles.column}>ساعت کار تایید: {item.approvedTime ?? '--'}</Text>
                  <Text style={styles.column}>میزان توقف: {calculateTimeDifference(item.startDate, item.startTime, item.endDate, item.endTime)} ساعت</Text>
                </View>
                <View style={styles.row}>
                  <Text style={styles.column}>محل استقرار: {item.location?.name ?? '--'}</Text>
                  <Text style={styles.column}>پیمانکار: {item.peymankar?.name ?? '--'}</Text>
                  <Text style={styles.column}>دستگاه: {item.machine?.name ?? '--'}</Text>
                  <Text style={styles.column}>نوع دستگاه: {item.machine?.type ?? '--'}</Text>
                </View>
                <View style={styles.row}>
                  <View style={styles.rows}>
                    <Text style={styles.Right}>
                      {item.machine.pelak
                        ? ` ${parsePelak(item.machine.pelak)?.part4} ${parsePelak(item.machine.pelak)?.part3} ${parsePelak(item.machine.pelak)?.part2} ${parsePelak(item.machine.pelak)?.part1}`
                        : "--"}
                    </Text>
                    <Text style={styles.Right}>پلاک:</Text>
                  </View>
                  <Text style={styles.column}>راننده: {item.driver?.name ?? '--'}</Text>
                  <Text style={styles.column}>تجهیز: {item.equipment?.name ?? '--'}</Text>
                  <Text style={styles.column}>اپراتور: {item.operator?.name ?? '--'}</Text>
                </View>
              </View>
              <Text style={styles.footer}>
                (نرم افزار مدیریت بارگیری بارگو) 91096293-021 www.bargosoftware.com
              </Text>
            </View>
          ))}
        </Page>
      ))}
    </Document>
  );
};

export default PdfReportStopRegistration;

PdfReportStopRegistration.propTypes = {
  data: PropTypes.array,
};
